<h1 mat-dialog-title>{{ message }}</h1>
<app-error-summary [error]="error" *ngIf="error"></app-error-summary>
<mat-dialog-actions>
    <button mat-button mat-dialog-close tabindex="-1" class="config__modal-cancel"
        (click)="dialogRef.close()">{{cancelButtonText}}</button>
    <button mat-button color="primary" (click)="onConfirmClick()" tabindex="1">{{confirmButtonText}}</button>
</mat-dialog-actions>